import React, { lazy } from 'react';
import Loadable from '../../components/Loadable';

const ExportDosificadoras = Loadable(lazy(() => import('./exportDosificadoras')));

const routes = [
    {
        path: 'export-dosificadoras',
        element: <ExportDosificadoras />,
    },
];

export default routes;
